import React from 'react';
import styled from 'styled-components';

const DividerStyle = styled.div`
	.divider {
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: 1px;
		background-color: ${props => props.theme.Cool_Gray_Light_3};
		box-shadow: -0.5px -0.5px 0.75px ${props => props.theme.Cool_Gray_Light_3} inset,
			0.5px 0.5px 0.5px ${props => props.theme.neomhorphicShadowDark} inset;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const Divider = () => {
	return (
		<DividerStyle>
			<div className='divider' />
		</DividerStyle>
	);
};
